import {
  Bold,
  Code,
  Heading,
  Italic,
  Link,
  List,
  ListOrdered,
  ListTodo,
  Quote,
  SquareCode,
  Strikethrough,
} from "lucide-react";
import type { RichTextFormat } from "./RichTextInput";

export const formats: {
  kind: RichTextFormat;
  label: string;
  icon: typeof Bold;
}[] = [
  { kind: "bold", label: "Bold (Ctrl+B)", icon: Bold },
  { kind: "italic", label: "Italic (Ctrl+I)", icon: Italic },
  { kind: "strike", label: "Strikethrough", icon: Strikethrough },
  { kind: "code", label: "Inline code", icon: Code },
  { kind: "link", label: "Link", icon: Link },
  { kind: "heading", label: "Heading", icon: Heading },
  { kind: "quote", label: "Quote", icon: Quote },
  { kind: "list", label: "Bulleted list", icon: List },
  { kind: "ordered-list", label: "Numbered list", icon: ListOrdered },
  { kind: "task-list", label: "Task list", icon: ListTodo },
  { kind: "code-block", label: "Code block", icon: SquareCode },
];
